import { PlayingCard } from "./PlayingCard";
import { fmt } from "@/poker/cards";
import { SKILL_LABEL, ordinal } from "@/poker/engine";

const AVATAR_COLORS = ["bg-amber-500", "bg-cyan-600", "bg-rose-600", "bg-emerald-600", "bg-violet-600", "bg-orange-600", "bg-sky-600", "bg-lime-600", "bg-fuchsia-600"];
const ACTION_STYLE = {
  Fold: "bg-slate-700 text-slate-300", Check: "bg-cyan-700 text-white", Call: "bg-emerald-600 text-white",
  Bet: "bg-amber-500 text-black", Raise: "bg-amber-500 text-black", "All-in": "bg-red-600 text-white",
};

export const Seat = ({ p, active, winner, isDealerHand, compact }) => {
  const showCards = !p.out && p.cards.length > 0;
  const faceUp = p.isHuman || p.revealed;
  return (
    <div
      data-testid={`seat-${p.id}`}
      className={`relative flex flex-col items-center ${p.out ? "opacity-40" : ""}`}
    >
      {showCards && (
        <div data-testid={p.isHuman ? "user-hole-cards" : `seat-${p.id}-cards`} className={`flex gap-0.5 sm:gap-1 -mb-3 z-0 ${p.folded && !p.isHuman ? "opacity-0" : ""}`}>
          {p.cards.map((c, i) => (
            <PlayingCard key={`${isDealerHand}-${i}`} card={faceUp ? c : null} faceDown={!faceUp} size={p.isHuman ? "lg" : compact ? "xs" : "sm"} dim={p.folded} delay={i * 120} />
          ))}
        </div>
      )}
      <div
        className={`relative z-10 flex items-center gap-2 rounded-xl px-2 py-1.5 sm:px-3 sm:py-2 ${compact ? "min-w-[78px] px-1.5 py-1" : "min-w-[96px]"} sm:min-w-[140px] seat-plate ${active ? "seat-active" : ""} ${winner ? "seat-winner" : ""}`}
      >
        <div className={`hidden sm:flex w-8 h-8 rounded-full items-center justify-center font-heading text-lg text-white ${AVATAR_COLORS[p.id]}`}>
          {p.name[0]}
        </div>
        <div className="flex flex-col leading-tight min-w-0">
          <span data-testid={`seat-${p.id}-name`} className="text-[11px] sm:text-sm font-semibold text-slate-100 truncate">
            {p.name}
            {!p.isHuman && <span className={`ml-1 text-[9px] sm:text-[10px] uppercase tracking-wider ${p.skill === "proplusplus" ? "text-fuchsia-400 font-bold" : p.skill === "proplus" ? "text-red-400 font-bold" : "text-slate-400"}`}>{SKILL_LABEL[p.skill]}</span>}
          </span>
          <span data-testid={`seat-${p.id}-stack`} className="font-mono text-xs sm:text-sm font-bold text-amber-400">
            {p.out ? `Out · ${ordinal(p.place)}` : p.allIn && p.stack === 0 ? "ALL-IN" : fmt(p.stack)}
          </span>
        </div>
        {active && <span data-testid={`seat-${p.id}-thinking`} className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-amber-400 animate-ping" />}
      </div>
      {p.lastAction && !p.out && (
        <span data-testid={`seat-${p.id}-last-action`} className={`mt-1 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-wider action-pop ${ACTION_STYLE[p.lastAction]}`}>
          {p.lastAction}
        </span>
      )}
      {p.revealed && p.handName && !p.folded && (
        <span data-testid={`seat-${p.id}-hand-name`} className="mt-1 text-[10px] sm:text-xs font-semibold text-cyan-300">{p.handName}</span>
      )}
    </div>
  );
};
